// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".privacy-policy[data-v-e7b03754]{width:100%;height:100vh;overflow-y:hidden;background-color:#fff;display:flex;flex-direction:column}.privacy-policy .page-container[data-v-e7b03754]{box-sizing:border-box;background-color:#fff;flex:1}.privacy-policy .page-container .iframe[data-v-e7b03754]{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
